import { render, staticRenderFns } from "./FolderLayer.vue?vue&type=template&id=04e5b087&"
import script from "./FolderLayer.vue?vue&type=script&lang=js&"
export * from "./FolderLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports